<template>
  <div class="status-container" :style="styles[data]">
    {{ situacaoDesc[data] }}
  </div>
</template>

<script>
export default {
	props: {
		data: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			situacaoDesc: {
				1: 'Pendente',
				2: 'Cancelado',
				3: 'Concluído',
				4: 'Avaliar Manualmente',
				5: 'Aguardando Captura',
				6: 'Captura em Andamento',
				7: 'Em Alerta',
				8: 'Aguardando Cancelamento',
				9: 'Cancelamento em andamento',
				10: 'Cancelamento aceito, aguardando',
				11: 'Não Autorizado',
			},
			styles: {
				1: 'background-color: #f7f3c4; color: #565004;',
				2: 'background-color: #dab3bb; color: #611635;',
				3: 'background-color: #abdcbc; color: #225233;',
				4: 'background-color: #dcc8ab; color: #524322;',
				5: 'background-color: #abdcd5; color: #223e52;',
				6: 'background-color: #b3abdc; color: #223152;',
				7: 'background-color: #ec7777; color: #3b1616;',
				8: 'background-color: #e01e371f; color: #e01e37;',
				9: 'background-color: #b21e351d; color: #b21e35;',
				10: 'background-color: #a11d331f; color: #a11d33;',
				11: 'background-color: #a11d331f; color: #a11d33;',
			},
		};
	},
};
</script>

<style scoped>
.status-container {
  display: flex;
  padding: 2.5px 5px;
  width: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  color: #0285dc;
  text-align: center;
  word-wrap: break-word;
}
</style>
